import { useFeatureGate } from '@statsig/react-bindings';
import { DIGITAL_INVOICE_TAX } from '@/constants/statsigFeatureGates';

/**
 * When the gate is on, render the V2 digital-invoice tax UI (`LineItemsV2` / `TotalSectionV2`).
 * When off, render V1 (`LineItems.tsx` / `TotalSection.tsx` in each feature folder).
 */
export function useDigitalInvoiceTaxFeature(): boolean {
  const { value } = useFeatureGate(DIGITAL_INVOICE_TAX);
  return value;
}
